import type {
  GamePhase,
  RoleId,
  RoleTeam,
} from "@cloudnest/one-night-ultimate-werewolf-engine";

export const roleLabels = new Map<RoleId, string>([
  ["werewolf", "늑대인간"],
  ["seer", "예언자"],
  ["robber", "강도"],
  ["troublemaker", "트러블메이커"],
  ["villager", "마을 주민"],
  ["hunter", "사냥꾼"],
  ["tanner", "태너"],
  ["minion", "미니언"],
  ["mason", "메이슨"],
  ["doppelganger", "도플갱어"],
  ["drunk", "주정뱅이"],
  ["insomniac", "불면증 환자"],
]);

export const phaseLabels = new Map<GamePhase, string>([
  ["setup", "자리 배치"],
  ["role-peek", "역할 확인"],
  ["night", "밤 행동"],
  ["day", "낮 토론"],
  ["vote", "투표"],
  ["reveal", "공개"],
  ["complete", "종료"],
]);

export const teamLabels = new Map<RoleTeam, string>([
  ["village", "시민편"],
  ["werewolf", "늑대편"],
  ["neutral", "중립"],
]);

export const outcomeReasonLabels = new Map<string, string>([
  ["werewolf-eliminated", "늑대인간이 제거되어 시민편 승리"],
  [
    "no-werewolves-no-deaths",
    "늑대인간이 없고 아무도 제거되지 않아 시민편 승리",
  ],
  ["werewolf-survived", "늑대인간이 살아남아 늑대편 승리"],
  ["minion-survived", "늑대인간이 없지만 미니언이 살아남아 늑대편 승리"],
  [
    "no-werewolves-village-loss",
    "늑대인간이 없는데 사망자가 발생해 시민편 패배 (승자 없음)",
  ],
  ["tanner-eliminated", "태너가 제거되어 태너 승리"],
  [
    "tanner-and-werewolf-eliminated",
    "태너와 늑대인간이 함께 제거되어 태너와 시민편 승리",
  ],
]);
